export function EditHTML (pEditor, pHTML)
{
  let oldCurrentHTML = '';


  this.openEditHTMLDialog = (pButton) =>
  {
    let elementBaseId = BEditor.Dialogs['HTML'].id,
        createMonacoEditor = BEditor.Dialogs['HTML'].createMonacoEditor,
        monacoEditor = BEditor.Dialogs['HTML'].monacoEditor;

    pEditor.pDialog = BEditor.Dialogs['HTML'].dialog;

    if (window.CaaSClientFeatureToggle && window.CaaSClientFeatureToggle.isNotOneForAllHTML)
    {
      elementBaseId = (pButton && pButton.getDialog()) ? pButton.getAttribute('id') + '_Dialog' : BEditor.Dialogs['HTML'].id;
      createMonacoEditor = (pButton && pButton.getDialog()) ? pButton.getAttribute('createMonacoEditor') : BEditor.Dialogs['HTML'].createMonacoEditor;
      monacoEditor = (pButton && pButton.getDialog()) ? pButton.getAttribute('monacoEditor') : BEditor.Dialogs['HTML'].monacoEditor;

      pEditor.pDialog = (pButton && pButton.getDialog()) ? pButton.getDialog() : BEditor.Dialogs['HTML'].dialog;
    }

    if (!pEditor.pDialog)
    {
      return false;
    }

    if (pEditor.pThis.isObjValid > 1 && BEditor.domHelpers.$(pEditor.iFrameId, pEditor.$winContent) && (pEditor.iFrameDoc) && (pEditor.iFrameDoc.body))
    {
      pEditor.range.cursor.show();
      pEditor.helpers.fixers.setFixGeckoTables({isRemove: true});
      pEditor.style.normalizer.fixWebKitHTMLInline();

      if (BEditor.browser.isIE)
      {
        pEditor.helpers.fixers.fixIELastLineRemoveFixer();
      }
    }

    let currentHTML = pEditor.content.getHtmlData();

    if (currentHTML == null)
    {
      if (pEditor.pThis.isObjValid > 1 && BEditor.domHelpers.$(pEditor.iFrameId, pEditor.$winContent) && (pEditor.iFrameDoc) && (pEditor.iFrameDoc.body))
      {
        pEditor.helpers.fixers.setFixGeckoTables({isFix: true});
        pEditor.style.normalizer.restoreWebKitHTMLInline(null);

        if (BEditor.browser.isIE)
        {
          pEditor.helpers.fixers.fixIELastLine();
        }
      }

      return false;
    }

    pEditor.range.save();

    currentHTML = pEditor.removeWaContentMarker(currentHTML);
    currentHTML = pEditor.helpers.userJavascript.restore(currentHTML);
    currentHTML = pEditor.anchor.restoreAnchors(currentHTML);
    currentHTML = pEditor.helpers.linkFixer.fixRelativeUrls(currentHTML);
    currentHTML = pEditor.anchor.restoreLinksToAnchors(currentHTML);
    currentHTML = pEditor.style.normalizer.convertDifferentTags(currentHTML);
    currentHTML = currentHTML.trim();

    oldCurrentHTML = currentHTML;

    BEditor.domHelpers.$(elementBaseId + '_SaveButton', BEditor.environment.topWindow).onclick = function() { pEditor.pThis.execCommand(pButton, 'replaceAllHTML'); };
    BEditor.domHelpers.$(elementBaseId + '_CancelButton', BEditor.environment.topWindow).onclick = function() { closeEditHTMLDialog(pButton); };

    if (!pEditor.pDialog.isCancelHandler)
    {
      pEditor.pDialog.Cancel.addHandler(function() { closeEditHTMLDialog(pButton); });
      pEditor.pDialog.isCancelHandler = true;
    }

    if (!monacoEditor)
    {
      createMonacoEditor(function(mEditor)
      {
        monacoEditor = mEditor;
        monacoEditor.setValue(currentHTML);
      });
    }
    else
    {
      monacoEditor.setValue(currentHTML);
    }

    pEditor.pDialog.show();
    pEditor.pDialog.setTip({ type: BEditor.UI.WaDialog.TipType.Attention, message: 'You can enter HTML or JavaScript code but please be careful: erroneous HTML or JavaScript code can affect formatting or cause issues with the content editor.' });

    pEditor.afterOpenDialog();
  };


  function replaceAllHTML (pButton)
  {
    let monacoEditor = BEditor.Dialogs['HTML'].monacoEditor,
        currentHTML = null;

    if (window.CaaSClientFeatureToggle && window.CaaSClientFeatureToggle.isNotOneForAllHTML)
    {
      monacoEditor = (pButton && pButton.getDialog()) ? pButton.getAttribute('monacoEditor') : BEditor.Dialogs['HTML'].monacoEditor;
    }

    if (pEditor.pDialog)
    {
      pEditor.image.currentImage = null;
      pEditor.image.webkitSelectedImage = null;
      pEditor.absImageSelected = null;

      currentHTML = monacoEditor.getValue();
      pEditor.closeDialog();

      if (currentHTML.trim() === '' || currentHTML === oldCurrentHTML)
      {
        currentHTML = pEditor.anchor.fixLinksToAnchors(currentHTML);
        replaceAllHTMLStep2(currentHTML);
      }
      else
      {
        currentHTML = pEditor.anchor.fixLinksToAnchors(currentHTML);
        pEditor.contentChecker.confirmClearMsHTML(replaceAllHTMLStep1, currentHTML, true);
      }
    }
  }


  function replaceAllHTMLStep1 (currentHTML, isChanged)
  {
    if (isChanged || !pEditor.isTidyServiceOn)
    {
      replaceAllHTMLStep2(currentHTML);
    }
    else
    {
      BEditor.EditorsManager.showPageShadingContainer(true, 'Cleaning HTML...', 1000);
      pEditor.contentChecker.setExcludeWordCheck();
      pEditor.repairAndCleanHtml(currentHTML, replaceAllHTMLStep2);
    }
  }


  const replaceAllHTMLStep2 = (currentHTML) =>
  {
    if (currentHTML != null)
    {
      currentHTML = pEditor.helpers.userJavascript.collect(currentHTML);
      currentHTML = pEditor.anchor.collectAnchors(currentHTML);
      currentHTML = pEditor.style.normalizer.restoreWebKitHTMLInline(currentHTML);
      currentHTML = pEditor.style.normalizer.removeWaWebKitSavedSpanIndex(currentHTML);
      currentHTML = pEditor.contentCleaner.clearHTML(currentHTML);
      currentHTML = pEditor.setWaContentMarker(currentHTML);

      this.setHTML(currentHTML);
      pEditor.anchor.reCollectAnchors();
      pEditor.image.objectFactory.checkAllImages();

      if (pEditor.pThis.isObjValid > 1 && BEditor.domHelpers.$(pEditor.iFrameId, pEditor.$winContent) && (pEditor.iFrameDoc) && (pEditor.iFrameDoc.body))
      {
        pEditor.helpers.fixers.setFixGeckoTables({isFix: true});
        pEditor.helpers.fixers.fixGeckoAlign();
      }
    }

    BEditor.EditorsManager.hidePageShadingContainer();
  };


  this.setHTML = function(newHtml)
  {
    if (newHtml != null)
    {
      pEditor.iFrameDoc.body.innerHTML = newHtml;
    }
  };


  function closeEditHTMLDialog (pButton)
  {
    if (pEditor.pDialog)
    {
      pEditor.closeDialog(pEditor.pDialog);

      if (pEditor.pThis.isObjValid > 1 && BEditor.domHelpers.$(pEditor.iFrameId, pEditor.$winContent) && (pEditor.iFrameDoc) && (pEditor.iFrameDoc.body))
      {
        pEditor.helpers.fixers.setFixGeckoTables({isFix: true});
        pEditor.helpers.fixers.fixGeckoAlign();
        pEditor.style.normalizer.restoreWebKitHTMLInline(null);
      }
    }
  }


  this.replaceAllHTML = replaceAllHTML;
}